/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-lines */

import {
  fetchCustomersMe,
  selectCustomerAndRedirect,
  selectCustomerBulkOutcomes,
  selectUseCaseBulkOutcomes,
  setRules,
} from 'actions';
import Modal from 'components/Modal';
import SelectRedesign from 'components/Select/SelectRedesign';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSelectCustomerList } from 'selectors/auth';
import { getModel } from 'selectors/models';
import { useSelector } from 'store';
import { Category, RuleGroup, UUID } from 'types';

type RouteParams = {
  modelId: UUID;
};

type ComponentProps = {
  selectedModels: string[];
  isModalOpen: boolean;
  toggleModalOpen: () => void;
  categories: Category[];
};

const EditBulkOutcomesModal: React.FC<ComponentProps> = ({
  selectedModels,
  isModalOpen,
  toggleModalOpen,
  categories,
}) => {
  const dispatch = useDispatch();
  const { modelId } = useParams<RouteParams>();

  const item = useSelector(getModel(modelId)) || { active: false };

  const customers = useSelector(getSelectCustomerList);

  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>();

  useEffect(() => {
    dispatch(fetchCustomersMe);
  }, [dispatch]);

  const handleEditButton = (): void => {
    if (!selectedCustomer) {
      setErrors({ selectedCustomer: 'You must select a Customer' });
      return;
    }

    setErrors({});

    const customer = customers.find((c) => c.uuid === selectedCustomer);

    const editRuleCategories: { rule: RuleGroup; categories: Category[] }[] = [];

    selectedModels.forEach((r) => {
      const rule = categories.find(
        (c) => c.rule_head?.rule_group_uuid && c.rule_head?.rule_group_uuid === r
      )?.rule_head?.rule_group;

      if (rule) {
        const ruleCategories = categories.filter(
          (c) =>
            c.rule_head?.rule_group_uuid &&
            c.rule_head.rule_group_uuid === rule.uuid &&
            c.customer_uuid === customer?.uuid
        );
        editRuleCategories.push({ rule, categories: ruleCategories });
      }
    });

    if (customer && customer.domain) {
      dispatch(setRules(editRuleCategories));
      dispatch(selectCustomerBulkOutcomes(customer));
      dispatch(selectUseCaseBulkOutcomes(item));

      dispatch(
        selectCustomerAndRedirect({
          domain: customer.domain,
          redirect: {
            routeName: 'customer-model-outcomes-manager',
            customerDomain: customer.domain,
            routeParams: { modelId },
            queryParams: { rule_uuids: selectedModels },
          },
        })
      );
    }
  };

  const customerOptions = customers.map((c) => ({ label: c.name || '', value: c.uuid }));

  const renderSelectCustomer = (
    <div className="pt-1 pl-2 pb-8 flex flex-col gap-4">
      <span className="text-heading-1">Add Customer Outcomes</span>
      <form className="flex flex-col items-start">
        <div className="w-full flex flex-col items-start gap-2">
          <div className="w-44 flex flex-col gap-1 text-body">
            <div className="flex flex-row gap-1">
              <span>Customer</span>
              <span className="litlingo-red-color">*</span>
            </div>

            <div className="flex-shrink-0 w-66">
              <SelectRedesign
                onChange={(value: string): void => {
                  setSelectedCustomer(value);
                }}
                options={customerOptions}
                value={selectedCustomer}
                placeholder="Select Customer"
                dataTestid="customer-select"
                className="h-9"
              />
              <div className="text-small">
                <span className="text-litlingo-alert">{errors?.selectedCustomer}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  return (
    <>
      {isModalOpen && (
        <Modal
          body={renderSelectCustomer}
          title=" "
          okButton
          okButtonText="Continue"
          okButtonOnClick={handleEditButton}
          toggleShowModal={toggleModalOpen}
          style={{ width: '37rem' }}
        />
      )}
    </>
  );
};

export default EditBulkOutcomesModal;
